module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-dots-6-f6bf5ac71d66b994748f6771fdfab015.svg";